import React from 'react';
import icon from './icon.jpg';
import { connect } from 'react-redux';

export const UserGuide = ({ href }) => {
  return (
    <div className='container'>
      <h1>User Guide</h1>
      <br />
      <br />
      <span>
        <a href={href} target='_blank'>
          <img src={icon} alt='icon' />
        </a>
      </span>
    </div>
  );
};

const mapStateToProps = (state) => {
  const isFSC = state?.auth?.isFSC;
  let href = isFSC ? `${process.env.PUBLIC_URL}/userguide_fsc.pdf` : `${process.env.PUBLIC_URL}/userguide.pdf`;
  return { href };
};

export default connect(mapStateToProps)(UserGuide);
